/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_LocalityInputs */

const cs_field_locality = /** @type {(inputs: Field_LocalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalita`)
};

const en_field_locality = /** @type {(inputs: Field_LocalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locality`)
};

/**
* | output |
* | --- |
* | "Locality" |
*
* @param {Field_LocalityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_locality = /** @type {((inputs?: Field_LocalityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_LocalityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_locality(inputs)
	return cs_field_locality(inputs)
});